var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, titleCase } from '@shapeable/utils';
import { CellLabel, IconToggleButton, useEntityTypePluralLabels, useLang } from '@shapeable/ui';
import { useMapUtils } from '../hooks/use-map-state';
import { EntityIcon, useEntityTypeIcons } from '@shapeable/icons';
import { useMapConfig } from '../context/map-config-context';
import pluralize from 'pluralize';
var cls = classNames('map-toggles');
export var EntityMapTogglesDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    font-size: ", ";\n    padding-top: ", ";\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 32px;\n  "], ["\n    ", ";\n    font-size: ", ";\n    padding-top: ", ";\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    width: 32px;\n  "])), theme.H_DOT_BG('bright', 2, 6), theme.FONT_SIZE(10), theme.UNIT(4))
});
var ToggleStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 1em;\n    cursor: pointer;\n    text-align: center;\n    margin-bottom: ", ";\n  "], ["\n    font-size: 1em;\n    cursor: pointer;\n    text-align: center;\n    margin-bottom: ", ";\n  "])), theme.UNIT(3))
});
var ToggleLabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-weight: 500;\n    font-size: 1em;\n    margin-bottom: ", ";\n  "], ["\n    font-weight: 500;\n    font-size: 1em;\n    margin-bottom: ", ";\n  "])), theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ToggleLabel: styled(CellLabel)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ToggleLabelStyles),
  Toggle: styled(IconToggleButton)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ToggleStyles)
};
export var EntityMapToggles = function (props) {
  var className = props.className;
  var t = useLang();
  var _a = useMapConfig().availableEntityTypeNames,
    availableEntityTypeNames = _a === void 0 ? [] : _a;
  var _b = useMapUtils(),
    toggleEntityType = _b.toggleEntityType,
    entityTypeIsVisible = _b.entityTypeIsVisible;
  var entityTypePluralLabels = useEntityTypePluralLabels();
  var entityTypeIcons = useEntityTypeIcons();
  if (!availableEntityTypeNames.length) {
    return null;
  }
  // this provides a default set of toggles, but some instances may need more fine-grained control
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.ToggleLabel, null, t('Show:')), availableEntityTypeNames.map(function (entityTypeName) {
    var Icon = entityTypeIcons[entityTypeName] || EntityIcon;
    return React.createElement(My.Toggle, {
      key: entityTypeName,
      onClick: function () {
        toggleEntityType(entityTypeName);
      },
      isActive: entityTypeIsVisible(entityTypeName),
      icon: React.createElement(Icon, null)
    }, t(entityTypePluralLabels[entityTypeName] || pluralize.plural(titleCase(entityTypeName))));
  }));
};
EntityMapToggles.cls = cls;
EntityMapToggles.defaultProps = EntityMapTogglesDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;